import * as Yup from "yup";

import { FormObjectMetadata } from "types/formMetadata";

export const LedgerAccountMetadata: FormObjectMetadata = {
  name: {
    fieldName: "name",
    displayName: "Name",
    _schema: Yup.string(),
    initialValue: "",
  },
  account_type: {
    fieldName: "account_type",
    displayName: "Account Type",
    _schema: Yup.string(),
    initialValue: null,
  },
  normal_side: {
    fieldName: "normal_side",
    displayName: "Normal Side",
    _schema: Yup.string(),
    initialValue: "debit",
  },
};
